import MapIcon from "../../../../assets/icons/map.svg";
import BriefcaseIcon from "../../../../assets/icons/briefcase.svg";
import UserIcon from "../../../../assets/icons/user.svg";

export interface PromptChat {
  title: string;
  description: string;
  icon: string;
}

export const promptChat: PromptChat[] = [
  {
    title: "Find a meeting room by location",
    description: "Show me available meeting rooms in Building A",
    icon: BriefcaseIcon,
  },
  {
    title: "Find a meeting room by capacity",
    description: "Find a meeting room for 10 people",
    icon: UserIcon,
  },
  {
    title: "Request specific equipment",
    description: "I need a meeting room with a projector and a whiteboard",
    icon: UserIcon,
  },
  {
    title: "Find a workspace",
    description: "I need a desk for work",
    icon: MapIcon,
  },
  {
    title: "Find a meeting room by items",
    description: "Which room has tea and coffee service?",
    icon: BriefcaseIcon,
  },
];
